<template>
  <div>
    <div class="datetime-picker d-flex justify-content-between pt-3">
      <div class="picker-wrapper">
        <SDatePicker v-model="formattedDate"
                     :label="$t('ui.date_time_picker.date')"
                     @update:model-value="handleDateInput"
        />
      </div>

      <div class="time-pickers">
        <p class="f-label w-100 mb-2">{{ $t('ui.date_time_picker.time') }}</p>
        <div class="d-flex align-items-center w-100">
          <div class="picker-wrapper">
            <SSelect
              id="hourSelect"
              v-model="models.hour"
              test-id="hour"
              :options="hours"
              :searchable="false"
              :select-label="`${$t('ui.date_time_picker.time')}: ${$t('ui.date_time_picker.hour')}`"
              hide-label
            />
          </div>
          <span class="time-indicator" aria-hidden="true">:</span>
          <div class="picker-wrapper">
            <SSelect
              id="minuteSelect"
              v-model="models.minute"
              test-id="minute"
              :searchable="false"
              :options="minutes"
              :select-label="`${$t('ui.date_time_picker.time')}: ${$t('ui.date_time_picker.minute')}`"
              hide-label
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import isMobileDeviceMixin from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'
import SDatePicker from 'src/components/base/datepicker/SDatePicker.vue'
import dateTimePicker from 'src/mixins/miscellaneous/dateTimePicker.js'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiDateTimeSelect',
  components: { SDatePicker },
  mixins: [isMobileDeviceMixin, dateTimePicker],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    models: {
      hour: 12,
      minute: 30,
      localDate: '',
    },

    localDate: '',
  }),

  computed: {
    hours() {
      return [...Array(24).keys()]
    },

    minutes() {
      return [...Array(60).keys()].filter((s) => s % 5 === 0)
    },

    formattedDate() {
      const momentDate = this.validateDate(this.models.localDate)
      momentDate.set({ hour: this.normalize(this.models.hour), minute: this.normalize(this.models.minute) })
      return this.$dateFormat.timestamp(momentDate)
    },
  },

  emits: ['update:modelValue'],

  methods: {
    validateDate(date) {
      return this.$moment(this.$moment(date).isValid() ? date : this.$moment())
    },

    normalize(num) {
      return num | 0
    },

    handleDateInput(newValue) {
      if (this.$moment(newValue).isValid()) {
        this.localDate = newValue
        this.$emit('update:modelValue', this.localDate)
      }
    },
  },

  watch: {
    modelValue: {
      handler(val) {
        const momentVal = this.$moment(val).isValid() ? this.$moment(val) : this.$moment().set({ hour: 12, minute: 0 }).add(1, 'days')

        this.models.localDate = momentVal.toDate()
        this.models.hour = momentVal.get('hours')
        this.models.minute = momentVal.get('minutes')
      },

      immediate: true,
    },
  },

  created() {},
}
</script>

<style scoped lang="scss">
.datetime-picker {
  align-items: center;

  @include media($mobile-s) {
    flex-direction: column;
    align-items: start;
  }
}

.time-pickers {
  width: 50%;
  flex-direction: column;

  @include media($mobile-s) {
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
  }
}

.picker-wrapper {
  width: 45%;

  @include media($mobile-s) {
    width: 100%;
  }

  .pseudo-input {
    font-weight: initial;
    padding: 9.5px 12px;
    background-color: $color-secondary !important;
    border-color: $color-gray-100;
  }

  .icon-chevron-down {
    top: 12px;
    right: 8px;
    pointer-events: none;
  }
}

.time-indicator {
  width: 10%;
  text-align: center;
}

:deep(.vc-popover-content-wrapper) {
  z-index: 9031 !important;
}
</style>
